(() => {
  function init() {
    const form = document.getElementById('CCStudioEnquiry');
    if (!form || form.dataset.ccReady) return;
    form.dataset.ccReady = 'true';
    const project = form.querySelector('[data-cc-project]');
    const tables = form.querySelector('[data-cc-tables]');
    const date = form.querySelector('[data-cc-date]');
    const estimate = form.querySelector('[data-cc-estimate]');
    const rush = form.querySelector('[data-cc-rush]');
    const preset = new URLSearchParams(location.search).get('suite');
    if (['signage', 'drinkware', 'ceremony', 'signature', 'couture'].includes(preset)) project.value = preset;
    const now = new Date();
    date.min = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    const money = value => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
    function update() {
      const counts = Math.max(0, Number(tables.value) || 0);
      const base = {ceremony:495, signature:1150, couture:2450}[project.value];
      const extras = ['signature', 'couture'].includes(project.value) ? Math.max(0, counts - 15) * 18 : 0;
      if (base) {
        estimate.textContent = `Proposed package: ${money(base)}${extras ? ` + ${money(extras)} for ${counts - 15} additional table numbers` : ''}. Estimated package total: ${money(base + extras)} before shipping, delivery, installation, tax or other changes.`;
        if (project.value === 'signature') estimate.textContent += ` Proposed deposit after acceptance: $350; balance ${money(base + extras - 350)} before those additional charges. No payment is taken here.`;
      } else if (project.value === 'signage') {
        estimate.textContent = 'Logo signage starts at $225 for single-layer work or $650 for dimensional compositions. Size, lighting, mounting and installation require a written quote.';
      } else if (project.value === 'drinkware') {
        estimate.textContent = 'Single customs: glass cans $38, insulated tumblers $45. Packs of 12, 24 or 48 are available at the listed per-item rate; request a separate volume quote.';
      } else {
        estimate.textContent = 'Choose a project to see its proposed starting price.';
      }
      rush.hidden = true;
      if (date.value) {
        const target = new Date(`${date.value}T12:00:00`);
        const today = new Date();
        today.setHours(12, 0, 0, 0);
        const days = Math.round((target - today) / 86400000);
        if (days < 0) {
          rush.textContent = 'Please select a future date.';
          rush.hidden = false;
        } else if (days < 21) {
          rush.textContent = 'Rush review required: your date is fewer than 21 days away. Availability, any rush fee, payment and production schedule must be accepted in writing before booking.';
          rush.hidden = false;
        } else if (days < 30) {
          rush.textContent = 'Your date is fewer than 30 days away. Payment timing will be agreed before acceptance; no past-due or automatic balance charge is scheduled.';
          rush.hidden = false;
        }
      }
    }
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
